import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'main-walking': {
			// ?safe&mock-data&utm_source=google&country=US&area=main-walking&exp=web_walking_to_lose_weight_keyword~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_walking_to_lose_weight_keyword'),
			},
		},
	},
]

export default config
